function CompanyInsightModel() {
    this.agent_analytics = []; // Array of agent analytics data
    this.alerthits = []; // Array of alerts triggered
    this.campliance_data = { // Compliance detection stats
        introcompany_detect: 0,
        recording_disclosure_detect: 0
    };
    this.play_list = []; // Array of playlist or call records
    this.questionhits = { // Questions asked by agent and client
        agent: [],
        client: []
    };
    this.sentiment = []; // Overall sentiment distribution
    this.talk_ratio = { // Talk time distribution
        agent: 0,
        client: 0,
        silence: 0
    };
    this.top_insights = []; // Key insights or flags
    this.topic_based_sentiment = []; // Sentiment tied to topics
    this.vocalys_score = 0; // Final calculated score
};

export {
    CompanyInsightModel
}